var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDiamond(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.0918 4.28615L3.29569 1H8.31982H13.3439L15.4918 4.28615L8.31982 13L1.0918 4.28615Z",
    fill: "#F5B800"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.29569 1L1.0918 4.28615M3.29569 1L5.36884 4.28615M3.29569 1H8.31982M1.0918 4.28615L8.31982 13M1.0918 4.28615H5.36884M8.31982 13L15.4918 4.28615M8.31982 13L5.36884 4.28615M8.31982 13L11.1961 4.28615M15.4918 4.28615L13.3439 1M15.4918 4.28615H11.1961M13.3439 1L11.1961 4.28615M13.3439 1H8.31982M5.36884 4.28615H11.1961M5.36884 4.28615L8.31982 1M11.1961 4.28615L8.31982 1",
    stroke: "#FF4400",
    strokeWidth: 0.792932,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiamond);
export default __webpack_public_path__ + "static/media/Diamond.35eb0236535a004a3b90.svg";
export { ForwardRef as ReactComponent };